module.exports = __webpack_public_path__ + "static/logo-15e23b89394546446b9d6ceeee237563.svg";